<template>
  <div>
    <van-dialog
      v-model="visible"
      :show-cancel-button="false"
      :show-confirm-button="false"
      class="dialog"
      :style="{
        background: `url(${backgroundImage}) no-repeat`
      }"
    >
      <div @click="removeClick" class="removeImage">
        <van-image :src="removeImage"> </van-image>
      </div>
      <div v-if="titleImage" class="title">
        <van-image :src="titleImage"> </van-image>
      </div>
      <div class="dialogWarp">
        <van-image
          class="headerImage"
          :src="require('../../../../../public/image/12/1/2.png')"
        >
        </van-image>
        <div class="list">
          <div class="listItem" v-for="(item, index) in list" :key="index">
            <div class="content">
              <van-image
                :src="
                  require(`../../../../../public/image/12/1/1/${item.imgid}.png`)
                "
              ></van-image>
              <span v-if="item.cdk" class="listWarp">
                {{ item.cdk }}
              </span>
              <span v-else class="listWarp1"> 開放後在郵件中領取 </span>
              <van-image
                v-clipboard:copy="item.cdk"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"
                v-if="item.cdk"
                class="copy"
                :src="require(`../../../../../public/image/12/1/4.png`)"
              ></van-image>
            </div>
          </div>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Toast } from 'vant'

export default {
  name: 'GetRewardsDialog',
  props: {
    visible: Boolean,
    titleImage: String,
    backgroundImage: String,
    removeImage: String,
    textImage: String,
    textImage1: String,
    imgid: String,
    list: Array
  },
  computed: {
    ...mapGetters(['phone', 'gameStatus'])
  },
  methods: {
    onCopy() {
      Toast.success('復製成功')
    },
    onError() {
      Toast.fail('復製失敗')
    },
    removeClick(val) {
      this.$emit('changeVisible', val)
    }
  }
}
</script>

<style lang="scss" scoped>
@keyframes heartbeat {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}
.dialog {
  width: 350px;
  background-size: 100% 100% !important;
  .title {
    padding: 2.5rem;
    padding-bottom: 0rem;
    /deep/ .van-image {
      width: 30%;
      display: block;
      margin: 0 auto;
    }
  }
}
.removeImage {
  position: absolute;
  width: 20px;
  z-index: 1000;
  top: 15px;
  right: 15px;
}
.dialogWarp {
  height: 400px;
  position: relative;
  margin: 0px 35px;
  margin-top: 10px;
  .headerImage {
    width: 62%;
    padding: 0px 10px;
  }
  .list {
    max-height: 320px;
    padding: 0px 10px;
    overflow: auto;
  }
  .listItem {
    .content {
      margin-top: 5px;
      display: flex;
      justify-content: space-between;
      /deep/ .van-image:nth-child(1) {
        width: 95px;
        display: inline-block;
        vertical-align: middle;
      }
      .copy {
        display: inline-block;
        vertical-align: middle;
        width: 45px;
      }
      span {
        display: inline-block;
        vertical-align: middle;
        color: rgb(93, 131, 184);
        font-size: 12px;
        width: 95px;
        background: url(../../../../../public/image/12/1/3.png) no-repeat;
        background-size: 100% 100%;
        text-align: center;
        line-height: 18px;
      }
      .listWarp1 {
        width: 120px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/route/src/prereg/components/rewardListDialog/index.vue